
import Trimaster from "@/plugins/servers/trimaster.js";

export default {
    data: function () {
        return {

        }
    },
    methods: {

        formatTemps(user, tempObj) {
            let res = {};

            if (!tempObj.tempAverage) {
                return {
                    tempMin: "--",
                    tempMax: "--",
                    tempAverage: "--",
                };
            }

            if (!Trimaster.displayMetric(user)) {
                res = {
                    tempMin: ((tempObj.tempMin * 9) / 5 + 32).toFixed(1) + "F",
                    tempMax: ((tempObj.tempMax.toFixed(2) * 9) / 5 + 32).toFixed(1) + "F",
                    tempAverage:
                        ((tempObj.tempAverage.toFixed(2) * 9) / 5 + 32).toFixed(1) + "F",
                };
            } else {
                res = {
                    tempMin: tempObj.tempMin.toFixed(2) + "C",
                    tempMax: tempObj.tempMax.toFixed(2) + "C",
                    tempAverage: tempObj.tempAverage.toFixed(2) + "C",
                };
            }
            return res;
        },

        formatCo2(co2Obj) {
            let res = {
                avg: "--",
                max: "--",
                min: "--",
            };

            if (co2Obj.current) res.avg = co2Obj.current.toFixed(0);
            if (co2Obj.maxReading) res.max = co2Obj.maxReading;
            if (co2Obj.minReading) res.min = co2Obj.minReading;

            return res;
        },

        getStats(user, callback) {
            let me = this;
            Trimaster.get("facilities/getStats", user.apitoken, {
                facility_id: user.facility_id,
            }).then(function ([res, err]) {
                console.log("facilitystats", res);
                // change into array of areas

                let results = [];
                let locationMap = {};
                for (let i = 0; i < res.rh.length; i++) {
                    locationMap[res.rh[i].areaname] = i;
                    results.push({
                        areaname: res.rh[i].areaname,
                        rh: res.rh[i],
                        co2: me.formatCo2(res.co2[i]),
                        temps: me.formatTemps(user, res.facilityTemps[i]),
                        growPlatformsInUse: res.growPlatformInUseCount[i],
                        growPlatformsCount: res.growPlatformsCount[i],
                        clonePlants: 0,
                        vegPlants: 0,
                        flowerPlants: 0,
                        disabledUnits: 0,
                        tickets: 0
                    });
                }
                if (Object.keys(locationMap).length > 0) {
                    for (let j = 0; j < res.plantCounts.length; j++) {

                        switch (res.plantCounts[j].growthStage) {
                            case 'Young':
                                results[locationMap[res.plantCounts[j].areaname]].clonePlants += res.plantCounts[j].numplants;
                                break;
                            case 'Vegetative':
                                results[locationMap[res.plantCounts[j].areaname]].vegPlants += res.plantCounts[j].numplants;
                                break;
                            case 'Flowering':
                                results[locationMap[res.plantCounts[j].areaname]].flowerPlants += res.plantCounts[j].numplants;
                                break;
                        }
                    }
                    for (let i = 0; i < res.disabledUnits.length; i++) {
                        results[locationMap[res.disabledUnits[i].areaname]].disabledUnits++;
                    }
                }

                for (let i=0; i<res.openHardwareTicketsCount.length; i++) {
                    if (res.openHardwareTicketsCount[i].areaname) {
                        if (results[locationMap[res.openHardwareTicketsCount[i].areaname]]) {
                        results[locationMap[res.openHardwareTicketsCount[i].areaname]].tickets += res.openHardwareTicketsCount[i].theCount;
                        }
                    } else {
                        results[0].tickets += res.openHardwareTicketsCount[i].theCount;
                    }
                }
                callback(results);
            })
        }
    }

};
